
import Services from "@/components/Services";

const ServicesPage = () => {
  return (
    <main className="pt-16">
      <Services />
    </main>
  );
};

export default ServicesPage;
